import templateUrl from "emun.on-demand/media/media-picker.htm";
import MediaPickerController from "emun.on-demand/media/media-picker.controller";
import open from "webmodals/open";

let editMediaPrompt = options => {
  let modalInstance = open({
    size: options.size || "lg",
    backdrop: "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: MediaPickerController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default editMediaPrompt;
